import { Box } from '@rbilabs/universal-components';

export const Wrapper = Box.withConfig({
  justifyContent: 'center',
  marginBottom: {
    base: '$3',
    md: '$4',
  },
});
